export const duration = (min, max) => {
  if (max === null && min === null) {
    return "";
  } else if (max === null) {
    return `(${min} hari)`;
  } else if (min === null) {
    return `(${max} hari)`;
  } else if (min === max) {
    return `(${min} hari)`;
  } else if (min === 0 && max === 1) {
    return `(Hari ini - Besok)`;
  }

  return `(${min}-${max} hari)`;
};
